import { RME_IN_REVIEW_ID, RME_IN_REVIEW_NAME } from '@m/constants/RmeStatus';
import { AssociatedVehicleUser, RmeStatus, Visit } from '@m/types/api';

export const vehicleUserHasSharedDriver = (
  requestingUserVehicle: AssociatedVehicleUser | undefined,
) => {
  return requestingUserVehicle?.role?.name === 'Shared';
};

export const isRmeStatusInReview = (rmeStatus?: RmeStatus | null): boolean => {
  return (
    rmeStatus?.status?.id === RME_IN_REVIEW_ID || rmeStatus?.status?.name === RME_IN_REVIEW_NAME
  );
};

// Single source of truth for "is this visit active" — open, not exited, and not
// hidden pending manual-exit review. Shared by Dashboard, Activity, and
// HomeActivitySection so the rule can't drift between them.
export const isVisitActive = (visit: Visit): boolean => {
  return visit.open && visit.end === null && !isRmeStatusInReview(visit.rmeStatus);
};
